import { Routes, ɵEmptyOutletComponent } from '@angular/router';
import { MaintenanceGuard } from './account/guards/maintenance.guard';
import { AutoReloadGuard } from './guards/auto-reload.guard';
import { LoggedInRedirectGuard } from './guards/logged-in-redirect.guard';
import { NotFoundGuard } from './guards/not-found.guard';
import { PromoSaveGuard } from './guards/promo-save.guard';
import { ReferralRedirectGuard } from './guards/referral-redirect.guard';
import { TrackingIdGuard } from './guards/tracking-id.guard';
import { routes as storyblokRoutes } from './storyblok/routes';

const allRoutes: Routes = [
  {
    path: 'convert/:format',
    loadChildren: () => import('./tools/convert/routes').then(m => m.routes),
  },
  { path: 'a', loadChildren: () => import('./account/routes').then(m => m.routes) },
  { path: 'r/:ref', component: ɵEmptyOutletComponent, canActivate: [ReferralRedirectGuard] },
  { path: 'auth', loadChildren: () => import('./auth/routes').then(m => m.routes) },
  {
    path: 'cant-edit-gallery',
    loadChildren: () => import('./public-cant-edit-gallery/routes').then(m => m.routes),
  },
  {
    path: 'gallery',
    loadChildren: () => import('./view-gallery/routes').then(m => m.routes),
    data: { noIndex: true },
  },
  {
    path: 'maintenance',
    loadComponent: () =>
      import('./pages/maintenance-page/maintenance-page.component').then(m => m.MaintenancePageComponent),
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'technical',
    loadChildren: () => import('./technical/routes').then(m => m.routes),
  },
  {
    path: '',
    children: storyblokRoutes,
    // loadChildren: () => import('./storyblok/routes').then(m => m.routes),
  },
  {
    path: '**',
    canActivate: [NotFoundGuard],
    loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
  },
];

export const routes: Routes = [
  {
    path: '',
    canActivate: [LoggedInRedirectGuard, TrackingIdGuard, PromoSaveGuard, AutoReloadGuard],
    children: allRoutes,
  },
];
